import { render, staticRenderFns } from "./TenantUserShowDetailsTab.vue?vue&type=template&id=4f5b2ac2"
import script from "./TenantUserShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./TenantUserShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports